import booking from "./booking";
import course from "./course";
import general from "./general";
import myaccount from "./myaccount";
import onlineExam from "./onlineExam";

export default [...general, ...booking, ...course, ...myaccount, ...onlineExam];
